export default __webpack_public_path__ + "static/media/twitter.a228c59d.svg";